import { render } from "./Pagination.vue?vue&type=template&id=3a5a9b5e&ts=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Common/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a5a9b5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a5a9b5e', __exports__)) {
    api.reload('3a5a9b5e', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=3a5a9b5e&ts=true", () => {
    api.rerender('3a5a9b5e', render)
  })

}


export default __exports__